'use strict'; 
import $ from "jquery";

import password_validation from '../../templates/Onboarding/password_validation.hbs';

function PasswordValidate(config){

    var PasswordValidate = {
        is_valid: true,
        password_field : config.password_field ?? '#password',
        password_rules: config.password_rules ?? null,
        hidden_icon: '.password-hidden',
        visible_icon: '.password-visible',
        validate_password: function(password){
            let pwd = password.trim();
            let result = [];
            this.valid = true;
            //if we choose to implement max spaces rule you'll need to decode the regex as without this we the json is broken 
            // decodeURIComponent(this.passowrd_rules.max_spaces.regex)
            //min length check 
            if(pwd.length < this.password_rules.min_length ){
                let error = {
                    valid: false,
                    text_label: this.password_rules.min_length+' characters minimum'
                };
                this.valid = false;
                result['min_length']= error;
            }
            else{
                let error = {
                    valid: true,
                    text_label: this.password_rules.min_length+' characters minimum'
                };
                result['min_length']= error;
            }
            //max length check 
            if(pwd.length > this.password_rules.max_length){
                let error = {
                    valid: false,
                    text_label: this.password_rules.max_length+' characters maximum'
                };
                result['max_length']= error;
                this.valid = false;
            }
            else{
                let error = {
                    valid: true,
                    text_label: this.password_rules.max_length+' characters maximum'
                };
                result['max_length']= error;
            }

            //combo for ui of both length matches 
            if(result.max_length.valid && result.min_length.valid){
                let error = {
                    valid: true,
                    text_label: 'Between '+this.password_rules.min_length+' and '+this.password_rules.max_length+' characters'
                };
                result['pwd_length']= error;
            }
            else{
                let error = {
                    valid: false,
                    text_label: 'Between '+this.password_rules.min_length+' and '+this.password_rules.max_length+' characters'
                };
                result['pwd_length']= error;
                this.valid = false;
            }

            //max_spaces- this is not implemented and probably will never be 
            //min_lowercase 
            let lowercase_match = pwd.match(new RegExp(this.password_rules.min_lowercase.regex.replaceAll(/\//g,""),'g')) ?? [];
            if( lowercase_match.length < this.password_rules.min_lowercase.count){
                let error = {
                    valid: false,
                    text_label: this.password_rules.min_lowercase.count+' lowercase character'
                };
                result['min_lowercase']= error;
                this.valid = false;
            }
            else{
                let error = {
                    valid: true,
                    text_label: this.password_rules.min_lowercase.count+' lowercase character'
                };
                result['min_lowercase']= error;

            }

            //min_uppercase
            let uppercase_match = pwd.match(new RegExp(this.password_rules.min_uppercase.regex.replaceAll(/\//g,""),'g')) ?? [];
            if(uppercase_match.length < this.password_rules.min_uppercase.count){
                let error = {
                    valid: false,
                    text_label: this.password_rules.min_uppercase.count+' uppercase characters'
                };
                result['min_uppercase']= error;
                this.valid = false;
            }
            else{
                let error = {
                    valid: true,
                    text_label: this.password_rules.min_uppercase.count+' uppercase characters'
                };
                result['min_uppercase']= error;
            }
            //min_numbers
            let number_match  = pwd.match(new RegExp(this.password_rules.min_numbers.regex.replaceAll(/\//g,""),'g')) ?? [];
            if(number_match.length < this.password_rules.min_numbers.count){
                let error = {
                    valid: false,
                    text_label: this.password_rules.min_numbers.count+' numbers'
                };
                result['min_numbers']= error;
                this.valid = false;
            }
            else{
                let error = {
                    valid: true,
                    text_label: this.password_rules.min_numbers.count+' numbers'
                };
                result['min_numbers']= error;
            }
            //min_special_characters 
            let special_characters_match_regex = decodeURIComponent(this.password_rules.min_special_characters.regex);
            let special_characters_match = pwd.match(new RegExp(special_characters_match_regex.replaceAll(/\//g,""),'g')) ?? [];
            if(special_characters_match.length < this.password_rules.min_special_characters.count){
                let error = {
                    valid: false,
                    text_label: this.password_rules.min_special_characters.count+' special characters'
                };
                result['min_special_characters']= error;
                this.valid = false;
            }
            else{
                let error = {
                    valid: true,
                    text_label: this.password_rules.min_special_characters.count+' special characters'
                };
                result['min_special_characters']= error;
            }

            //Dictonary match 
            var sum_dictionary = 0;
            this.password_rules.dictionary.words.forEach(word => {
                if(word.length > 0){
                    // we need to parse the html entities so that we can compare them correctly aka ' or special letters 
                    // alternative would be to use a library "lodash" or some funky stuff with charCodeAt
                    let test_word = $('<div>').html(word).text();
                    // we also need to deal with special characters such as + at the start of a phone number 
                    let match = pwd.toLowerCase().match(new RegExp(this.escapeRegExp(test_word).toLowerCase(),'g'));
                    if(match != null){
                        // sum_dictionary++;
                        //this is the word length / password length multiplied by the number of times it matched 
                        sum_dictionary += ((test_word.length/pwd.length)*match.length);
                    }
                }
            });
            if(sum_dictionary> this.password_rules.dictionary.threshold){
                let error = {
                    valid: false,
                    text_label:"Common phrases (like 'password') and personal phrases like your name, email, or company name can't be used"
                };
                result['dictionary']= error;
                this.valid = false;
            }
            else{

            }
           
            result['valid'] = this.valid;
            //manage the UI 
            let area = $(password_validation({errors: result}));
            if($('.password-validation').length>0){
                $('.password-validation').replaceWith(area);
            }
            else{
                $(this.password_field).parent().append(area);
            }
            
            //return the bool result 
            return this.valid;

        }, 
        handle_password_keyup:function(e){
            this.validate_password($(e.currentTarget).val());
        },
        handle_show_password: function(e){
            //change this input type 
            $(this.password_field).attr('type','text');
            //update the image 
            $('body').find('.password .visibility').remove();
            $('body').find(this.password_field).parent().append('<img class="visibility password-visible" src="/assets/img/icons/icon-password-show.svg"/>');
        },
        handle_hide_password: function(e){
            //change this input type 
            $(this.password_field).attr('type','password');
            //update the image 
            $('body').find('.password .visibility').remove();
            $('body').find(this.password_field).parent().append('<img class="visibility password-hidden" src="/assets/img/icons/icon-password-hidden.svg"/>');
        },
        escapeRegExp: function(string){
            //handle values from the dictionary that have characters that need to be escaped in a js regex 
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        },
        init: function(config){
             //bind the validator to the password field 
            $('body').on('keyup', this.password_field, this.handle_password_keyup.bind(this));
            $('body').on('click', this.hidden_icon, this.handle_show_password.bind(this));
            $('body').on('click', this.visible_icon, this.handle_hide_password.bind(this));



            $('body').find(this.password_field).parent().append('<img class="visibility password-hidden" src="/assets/img/icons/icon-password-hidden.svg"/>');
            //this was not working so removed the events system for now 
            // this.jquery_events[this.password_field] = new PasswordEvent('keyup', this.password_field, this.handle_password_keyup.bind(this));

            //sets the default state to list of empty req's 
            this.validate_password('');
        }

    }
    PasswordValidate.init(config);

    return PasswordValidate;
}

export {PasswordValidate};